import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { RenderDatePicker } from './Base';

import { RenderInput } from './Base';
import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog, Button, MenuItem } from '@blueprintjs/core';
import { Select, ItemPredicate } from "@blueprintjs/select";

import { getYearsArray, filterRecipients } from '../../../../helpers/functions';
import { saveDonorRecipient } from '../../../../redux/actions/donorRecipient.actions';

export const SchoolYearOptionComponents = {
    DISPLAY_VALUE: "DISPLAY_VALUE",
    BACKEND_VALUE: "BACKEND_VALUE"
}

export const AdditionalSchoolYearOptions = {
    ONGOING: "ONGOING",
    UNKNOWN: "UNKNOWN",
}

// special values set by backend - check with them before changing these
export const SPECIAL_LINK_SCHOOL_YEAR_IDENTIFIER = {
    [AdditionalSchoolYearOptions.ONGOING]: {
        [SchoolYearOptionComponents.DISPLAY_VALUE]: "Ongoing",
        [SchoolYearOptionComponents.BACKEND_VALUE]: null,
    },
    [AdditionalSchoolYearOptions.UNKNOWN]: {
        [SchoolYearOptionComponents.DISPLAY_VALUE]: "Unknown",
        [SchoolYearOptionComponents.BACKEND_VALUE]: null,
    },
}

class AddDonorRecipientModal extends Component {
    constructor(props) {
        super(props);

        var yearOptions = getYearsArray().map((v, i) => (<option key={i} value={v}>{v}</option>));
        this.unknownLinkId = SPECIAL_LINK_SCHOOL_YEAR_IDENTIFIER[AdditionalSchoolYearOptions.UNKNOWN];
        this.ongoingLinkId = SPECIAL_LINK_SCHOOL_YEAR_IDENTIFIER[AdditionalSchoolYearOptions.ONGOING];

        this.link_start_school_year_options = [
            <option
                key={-1}
                value={this.unknownLinkId[SchoolYearOptionComponents.BACKEND_VALUE]}
            >{this.unknownLinkId[SchoolYearOptionComponents.DISPLAY_VALUE]}
            </option>,
            ...yearOptions
        ]
        this.link_end_school_year_options = [
            <option
                key={-1}
                value={this.ongoingLinkId[SchoolYearOptionComponents.BACKEND_VALUE]}
            >{this.ongoingLinkId[SchoolYearOptionComponents.DISPLAY_VALUE]}
            </option>,
            ...yearOptions
        ]

        this.emptyForm = {
            link_start_school_year: this.unknownLinkId[SchoolYearOptionComponents.BACKEND_VALUE],
            link_end_school_year: this.ongoingLinkId[SchoolYearOptionComponents.BACKEND_VALUE],
            notes: '',
        };
        this.state = {
            showModal: false,
            donorId: null,
            recipientId: null,
            donorRecipientLinkId: null,
            filterValue: '',
            form: this.emptyForm,
        };
    }
    componentDidMount() {
        window.addEventListener('open-add-donor-recipient-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-add-donor-recipient-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { donorRecipient: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;

        // if we are editing an existing link
        const form = detail.id ? {
            link_start_school_year: detail.link_start_school_year ? detail.link_start_school_year : null,
            link_end_school_year: detail.link_end_school_year ? detail.link_end_school_year : null,
            notes: detail.notes,
        } : this.emptyForm;

        this.setState({
            showModal: true,
            recipientId: detail.recipient_id,
            donorId: detail.donorId,
            donorRecipientLinkId: detail.id,
            form: form,
        });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, value }) => {
        const { form } = this.state;
        form[value] = text;
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveDonorRecipient();
        }
    }

    saveDonorRecipient = () => {
        const { donorId, recipientId, donorRecipientLinkId, form } = this.state;

        this.props.saveDonorRecipient({ donorId, recipientId, donorRecipientLinkId, form });
    }

    recipientItemRenderer = (item, {index, handleClick}) => {
        const isSelected = this.state.recipientId === item.id;
        return (
            <MenuItem
                icon={isSelected ? 'tick' : 'blank'}
                key={index}
                label={`${item.gender} | ${item.city_of_school} | ${item.country_of_school}`}
                onClick={handleClick}
                text={`${item.first_name} ${item.middle_name} ${item.last_name}`}
            />
        );
    }

    onRecipientSelect = (item) => {
        this.setState({ recipientId: parseInt(item.id, 10) });
    }

    handleFilterChange = (event) => {
        this.setState({ filterValue: event.target.value });
    }

    renderTag = (id) => {
        const { recipientsById } = this.props.recipientState;
        const recipient = recipientsById[id]
        return (
            `${recipient.first_name} ${recipient.middle_name} ${recipient.last_name}`
        );
    }

    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.donorRecipient;
        const { recipients, recipientsById } = this.props.recipientState;
        const selectedRecipient = this.state.recipientId ? recipientsById[this.state.recipientId] : null;

        return (
            <Dialog icon='link'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                title="Save Recipient Link">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row title-padding"><strong>Recipient to link (required)</strong></div>
                            <div className="flex-row input-padding">
                                <Select
                                    items={recipients}
                                    disabled={this.state.donorRecipientLinkId}
                                    filterable
                                    itemRenderer={this.recipientItemRenderer}
                                    itemPredicate={filterRecipients}
                                    onItemSelect={this.onRecipientSelect}
                                    popoverProps={{ usePortal: false, minimal: true }}
                                    inputProps={{ value: this.state.filterValue, onChange: this.handleFilterChange }}
                                    noResults={<MenuItem disabled={true} text="No results." />} >
                                    <Button
                                        text={
                                            selectedRecipient ?
                                            `${selectedRecipient.first_name} ${selectedRecipient.middle_name} ${selectedRecipient.last_name} (${selectedRecipient.gender} | ${selectedRecipient.city_of_school} | ${selectedRecipient.country_of_school})`
                                            : 'Select a Recipient'
                                        }
                                        rightIcon={this.state.donorRecipientLinkId ? "disable": "double-caret-vertical"}
                                    />
                                </Select>
                            </div>
                            <div className="flex-row title-padding"><strong>School year the link started</strong></div>
                            <div className="flex-row input-padding">
                                <div className="pt-select">
                                    <select
                                        value={form.link_start_school_year}
                                        onChange={event => this.onChangeHandler({text: Number(event.target.value), value: 'link_start_school_year'})}>
                                        {this.link_start_school_year_options}
                                    </select>
                                </div>
                            </div>
                            <div className="flex-row title-padding"><strong>School year the link ended</strong></div>
                            <div className="flex-row input-padding">
                                <div className="pt-select">
                                    <select
                                        value={form.link_end_school_year}
                                        onChange={event => this.onChangeHandler({text: Number(event.target.value), value: 'link_end_school_year'})}>
                                        {this.link_end_school_year_options}
                                    </select>
                                </div>
                            </div>
                            <div className="flex-row title-padding notes-bolded">
                                <RenderInput
                                    label="Notes"
                                    name="notes"
                                    value={form.notes}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler}
                                />
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton
                                    className="pt-button pt-fill pt-intent-primary pt-large"
                                    text="Save Recipient Link"
                                    onClick={this.saveDonorRecipient}
                                    isLoading={saveLoading}
                                    disabled={!selectedRecipient}
                                />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    (state) => ({
        recipientState: state.recipient,
        donorRecipient: state.donorRecipient
    }),
    { saveDonorRecipient }
)(AddDonorRecipientModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/DonorRecipientModal.jsx